"use client";

import { type InfoLineProps } from "#/components/InfoLine/InfoLine";
import { tooltips } from "#/config/tooltips";
import { getImpactColor } from "#/utils/getImpactColor";

import { useCalculateUserRiskForCombo } from "../../../../PricesTable.hooks";

export const usePortfolioImpactAndGreeksController = () => {
  const {
    imr,
    mmr,
    userRisk: { im, greeks },
    portfolioState,
  } = useCalculateUserRiskForCombo();

  const marginData: InfoLineProps[] = [
    {
      data: {
        label: "Margin Usage (IMΔ)",
        amount: im - (portfolioState?.im ?? 0),
        unit: "USD",
      },
      tooltip: tooltips.marginUsage,
    },
    {
      data: {
        label: "Available Margin",
        amount: (portfolioState?.equity ?? 0) - im,
        unit: "USD",
      },
      tooltip: tooltips.availableMargin,
    },
    {
      data: {
        label: "IMr",
        change: {
          from: (portfolioState?.imr ?? 0) * 100,
          to: imr * 100,
          template: "0.00%",
        },
      },
      tooltip: tooltips.IMr,
      leftLabelClassName: getImpactColor(portfolioState?.imr ?? 0),
      rightLabelClassName: getImpactColor(imr),
    },
    {
      data: {
        label: "MMr",
        change: {
          from: (portfolioState?.mmr ?? 0) * 100,
          to: mmr * 100,
          template: "0.00%",
        },
      },
      tooltip: tooltips.MMr,
      leftLabelClassName: getImpactColor(portfolioState?.mmr ?? 0),
      rightLabelClassName: getImpactColor(mmr),
    },
  ];

  const greeksData: InfoLineProps[] = [
    {
      data: {
        label: "Δ Delta",
        change: {
          from: portfolioState?.greeks.delta ?? 0,
          to: greeks.delta ?? 0,
          template: "0.00",
        },
      },
      tooltip: tooltips.Delta,
    },
    {
      data: {
        label: "Γ Gamma",
        change: {
          from: portfolioState?.greeks.gamma ?? 0,
          to: greeks.gamma ?? 0,
          template: "0.00000",
        },
      },
      tooltip: tooltips.gamma,
    },
    {
      data: {
        label: "V Vega",
        change: {
          from: portfolioState?.greeks.vega ?? 0,
          to: greeks.vega ?? 0,
          template: "0.00",
        },
      },
      tooltip: tooltips.vega,
    },
    {
      data: {
        label: "Θ Theta",
        change: {
          from: portfolioState?.greeks.theta ?? 0,
          to: greeks.theta ?? 0,
          template: "0.00",
        },
      },
      tooltip: tooltips.theta,
    },
  ];

  return {
    marginData,
    greeksData,
  };
};
